export const getEntryValue = (entry: Element, name: string) =>
  entry.getElementsByTagName(name)[0]?.textContent ?? '';
